import { render, staticRenderFns } from "./IdAgreement.vue?vue&type=template&id=aff632c4&scoped=true&"
import script from "./IdAgreement.vue?vue&type=script&lang=js&"
export * from "./IdAgreement.vue?vue&type=script&lang=js&"
import style0 from "./IdAgreement.vue?vue&type=style&index=0&id=aff632c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff632c4",
  null
  
)

export default component.exports